'use client';

import { GetWrapupType, WrapupModuleMapData, WrapupModulePlayedData } from "@/src/server/models/seasonal/wrapup/modules/getwrapup";
import IWrapupModule from "./imodule";
import WrapupModuleMapsComponent from "./mapcomponent";

export default class WrapupModuleMaps implements IWrapupModule {
    constructor() { }

    get id(): string { return 'map'; }
    get name(): string { return 'Maps'; }

    canRender(data: GetWrapupType): boolean {
        const mapData =  (data?.data?.map as WrapupModuleMapData);
        return mapData?.topMap != null;
    }

    getComponentClass() {
        return WrapupModuleMapsComponent;
    }
}
